export const actions = {
  CATEGORIA_HOME_ALL_LOAD_REQUESTED: 'CATEGORIA_HOME_ALL_LOAD_REQUESTED',
  CATEGORIA_HOME_ALL_LOAD_SUCCEEDED: 'CATEGORIA_HOME_ALL_LOAD_SUCCEEDED',
  CATEGORIA_HOME_ALL_LOAD_FILED: 'CATEGORIA_HOME_ALL_LOAD_FILED',

  CATEGORIA_HOME_SELECTED_LOAD_REQUESTED: 'CATEGORIA_HOME_SELECTED_LOAD_REQUESTED',
  CATEGORIA_HOME_SELECTED_LOAD_SUCCEEDED: 'CATEGORIA_HOME_SELECTED_LOAD_SUCCEEDED',
  CATEGORIA_HOME_SELECTED_LOAD_FILED: 'CATEGORIA_HOME_SELECTED_LOAD_FILED',

  CATEGORIA_ESPECIAL_SELECTED_LOAD_REQUESTED: 'CATEGORIA_ESPECIAL_SELECTED_LOAD_REQUESTED',
  CATEGORIA_ESPECIAL_SELECTED_LOAD_SUCCEEDED: 'CATEGORIA_ESPECIAL_SELECTED_LOAD_SUCCEEDED',
  CATEGORIA_ESPECIAL_SELECTED_LOAD_FILED: 'CATEGORIA_ESPECIAL_SELECTED_LOAD_FILED',

  CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_REQUESTED: 'CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_REQUESTED',
  CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_SUCCEEDED: 'CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_SUCCEEDED',
  CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_FILED: 'CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_FILED',

  CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_REQUESTED: 'CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_REQUESTED',
  CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_SUCCEEDED: 'CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_SUCCEEDED',
  CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_FILED: 'CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_FILED',

  CATEGORIA_HOME_BY_FECHA_ID_LOAD_REQUESTED: 'CATEGORIA_HOME_BY_FECHA_ID_LOAD_REQUESTED',
  CATEGORIA_HOME_BY_FECHA_ID_LOAD_SUCCEEDED: 'CATEGORIA_HOME_BY_FECHA_ID_LOAD_SUCCEEDED',
  CATEGORIA_HOME_BY_FECHA_ID_LOAD_FILED: 'CATEGORIA_HOME_BY_FECHA_ID_LOAD_FILED',

  CATEGORIA_HOME_UPDATE_REQUESTED: 'CATEGORIA_HOME_UPDATE_REQUESTED',
  CATEGORIA_HOME_UPDATE_SUCCEEDED: 'CATEGORIA_HOME_UPDATE_SUCCEEDED',
  CATEGORIA_HOME_UPDATE_FILED: 'CATEGORIA_HOME_UPDATE_FILED',

  CATEGORIA_HOME_INSERT_REQUESTED: 'CATEGORIA_HOME_INSERT_REQUESTED',
  CATEGORIA_HOME_INSERT_SUCCEEDED: 'CATEGORIA_HOME_INSERT_SUCCEEDED',
  CATEGORIA_HOME_INSERT_FILED: 'CATEGORIA_HOME_INSERT_FILED',

  CATEGORIA_HOME_DELETE_REQUESTED: 'CATEGORIA_HOME_DELETE_REQUESTED',
  CATEGORIA_HOME_DELETE_SUCCEEDED: 'CATEGORIA_HOME_DELETE_SUCCEEDED',
  CATEGORIA_HOME_DELETE_FILED: 'CATEGORIA_HOME_DELETE_FILED',

  CATEGORIA_HOME_UPDATE_SELECTED_REQUESTED: 'CATEGORIA_HOME_UPDATE_SELECTED_REQUESTED',
  CATEGORIA_HOME_UPDATE_SELECTED_SUCCEEDED: 'CATEGORIA_HOME_UPDATE_SELECTED_SUCCEEDED',
  CATEGORIA_HOME_UPDATE_SELECTED_FILED: 'CATEGORIA_HOME_UPDATE_SELECTED_FILED',

  CATEGORIA_ESPECIAL_UPDATE_SELECTED_REQUESTED: 'CATEGORIA_ESPECIAL_UPDATE_SELECTED_REQUESTED',
  CATEGORIA_ESPECIAL_UPDATE_SELECTED_SUCCEEDED: 'CATEGORIA_ESPECIAL_UPDATE_SELECTED_SUCCEEDED',
  CATEGORIA_ESPECIAL_UPDATE_SELECTED_FAILED: 'CATEGORIA_ESPECIAL_UPDATE_SELECTED_FAILED',
}

export const getCategoriaAllAction = (dispatch, idiomaId) => {
  dispatch({
    type: actions.CATEGORIA_HOME_ALL_LOAD_REQUESTED,
    payload: idiomaId,
  })
}

export const getCategoriaHomeSelectedAction = (dispatch, idiomaId) => {
  dispatch({
    type: actions.CATEGORIA_HOME_SELECTED_LOAD_REQUESTED,
    payload: idiomaId,
  })
}

export const getCategoriaEspecialSelectedAction = (dispatch, idiomaId) => {
  dispatch({
    type: actions.CATEGORIA_ESPECIAL_SELECTED_LOAD_REQUESTED,
    payload: idiomaId,
  })
}

export const getCategoriaHomeByCategoriaIdAction = (dispatch, categoriaId) => {
  dispatch({
    type: actions.CATEGORIA_HOME_BY_CATEGORIA_ID_LOAD_REQUESTED,
    payload: categoriaId,
  })
}

export const getCategoriaHomeByEtiquetaIdAction = (dispatch, etiquetaId) => {
  dispatch({
    type: actions.CATEGORIA_HOME_BY_ETIQUETA_ID_LOAD_REQUESTED,
    payload: etiquetaId,
  })
}

export const getCategoriaHomeByFechaIdAction = (dispatch, fechaId) => {
  dispatch({
    type: actions.CATEGORIA_HOME_BY_FECHA_ID_LOAD_REQUESTED,
    payload: fechaId,
  })
}

export const onSubmitInsertCategoriaHomeFormAction = (dispatch, formCategoriaHome) => {
  dispatch({
    type: actions.CATEGORIA_HOME_INSERT_REQUESTED,
    payload: formCategoriaHome,
  })
}

export const updateCategoriasHomeSelectedAction = (dispatch, formCategoriaHome) => {
  dispatch({
    type: actions.CATEGORIA_HOME_UPDATE_SELECTED_REQUESTED,
    payload: formCategoriaHome,
  })
}

export const updateCategoriasEspecialSelectedAction = (dispatch, formCategoriaHome) => {
  dispatch({
    type: actions.CATEGORIA_ESPECIAL_UPDATE_SELECTED_REQUESTED,
    payload: formCategoriaHome,
  })
}

export const onSubmitUpdateCategoriasHomeFormAction = (
  dispatch,
  formCategoriasHome,
  tipoConfiguracionParam,
  id,
) => {
  dispatch({
    type: actions.CATEGORIA_HOME_UPDATE_REQUESTED,
    payload: formCategoriasHome,
    tipoConfiguracion: tipoConfiguracionParam,
    idTipoConfiguracion: id,
  })
}

export const deleteCategoriaHomeAction = (dispatch, id) => {
  dispatch({
    type: actions.CATEGORIA_HOME_DELETE_REQUESTED,
    payload: id,
  })
}
